<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Ghi nhận hoa hồng</h1>
      <div class="float-right btn-group">
        <button
          type="button"
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i>
          {{ loaddingExport ? 'Đang tạo file...' : ' Tải file mẫu' }}
        </button>
        <button
          type="button"
          @click="triggerFileUpload"
          :disabled="isUploading"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-import"></i>
          {{ isUploading ? 'Đang tải...' : 'Tải lên file' }}
        </button>

        <button
          type="button"
          @click="exportDataListToExcel"
          :disabled="isUploading"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-import"></i>
          {{ showLoading ? 'Đang tải...' : 'Tải file excel' }}
        </button>
      </div>
    </div>

    <input
      type="file"
      ref="fileInput"
      @change="handleFileUpload"
      accept=".xlsx,.xls,.csv"
      style="display: none"
    />

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.partner"
              class="form-control f12 hc-37 text-search"
              placeholder="Đối tác"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.deviceSerial"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial thiết bị"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.deviceName"
              :options="optionType"
              placeholder="Tên thiết bị"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="filters.status" :options="statusOptions" placeholder="Trạng thái" />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày ghi nhận
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <button
              type="submit"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="p-10 pt-0">
            <div class="d-flex flex-row">
              <div class="box-header">
                Tổng:
                <strong class="text-primary"
                  >&nbsp;{{ pagination?.total?.toLocaleString('vi-VN') }}</strong
                >
              </div>
            </div>
            <b-table
              hover
              sticky-header
              head-variant="light"
              responsive
              :items="dataTable"
              :fields="fields"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>

              <template #cell(status)="{ item }">
                <div>
                  {{ getNameStatus(item?.status) }}
                </div>
              </template>

              <template #cell(recordDate)="{ item }">
                <div>
                  {{ item?.recordDate | formatDate('DD/MM/YYYY') }}
                </div>
              </template>

              <template #cell(actions)="{ item }">
                <div class="text-center">
                  <a
                    target="_blank"
                    class="btn btn-sm btn-outline-primary btn-primary text-white"
                    @click="$router.push(`/device/${item?.deviceId}`)"
                  >
                    Chi tiết TB
                  </a>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-pagination
                v-model="pagination.page"
                :total-rows="pagination.total"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal thông báo kết quả upload -->
    <b-modal
      v-model="showUploadResultModal"
      title="Kết quả tải file"
      size="md"
      hide-footer
      centered
    >
      <div v-if="uploadResult">
        <!-- Thông tin tổng quan -->
        <div class="mb-3">
          <div class="alert alert-info">
            <h6 class="mb-2">Thông tin tổng quan:</h6>
            <p class="mb-1"><strong>Tổng số dòng:</strong> {{ uploadResult.totalRows }}</p>
            <p class="mb-1">
              <strong>Thành công:</strong>
              <span class="text-success">{{ uploadResult.successCount }}</span>
            </p>
            <p class="mb-0">
              <strong>Thất bại:</strong>
              <span class="text-danger">{{ uploadResult.errorCount }}</span>
            </p>
          </div>
        </div>

        <!-- Danh sách lỗi nếu có -->
        <!-- <div v-if="uploadResult.errorCount > 0" class="mb-3">
          <h6 class="text-danger mb-2">Chi tiết lỗi:</h6>
          <div class="error-list-container" style="max-height: 300px; overflow-y: auto;">
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 80px;">Dòng</th>
                    <th style="width: 150px;">Serial thiết bị</th>
                    <th>Lỗi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(error, index) in uploadResult.errors" :key="index">
                    <td class="text-center">{{ error.rowNumber }}</td>
                    <td>{{ error.serialDevice }}</td>
                    <td class="text-danger">{{ error.errorMessage }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> -->

        <!-- Nút hành động -->
        <div class="text-right">
          <button
            v-if="uploadResult.errorCount > 0"
            type="button"
            class="btn btn-outline-danger mr-2"
            @click="downloadErrorFile"
            :disabled="isDownloadingError"
          >
            <i class="bx bx-download"></i>
            {{ isDownloadingError ? 'Đang tải...' : 'Tải file lỗi' }}
          </button>
          <button type="button" class="btn btn-secondary" @click="closeUploadResultModal">
            Đóng
          </button>
        </div>
      </div>
    </b-modal>
    <ModalExportNoti ref="uploadNotif" />
  </div>
</template>

<script>
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import { showMess } from '@/config/utils'
  import Config from '@/thirdParty/config'
  import { KpiRoseService } from '@/services/kpi-rose.service'
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import { DeviceService } from '@/services/device.service'
  import { CommonService } from '@/services/common.service'

  export default {
    components: { ModalExportNoti },
    data() {
      return {
        Config,
        filters: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        statusOptions: [
          { id: 'NOT_COMMISSIONED', text: 'Chưa tính hoa hồng', class: 'badge-info' },
          { id: 'COMMISSIONED', text: 'Đã tính hoa hồng', class: 'badge-success' },
        ],
        isLoading: true,
        fields: [
          { key: 'partner', label: 'Đối tác' },
          { key: 'deviceSerial', label: 'Serial thiết bị' },
          { key: 'deviceName', label: 'Tên thiết bị' },
          { key: 'status', label: 'Trạng thái' },
          { key: 'recordDate', label: 'Ngày ghi nhận' },
          { key: 'note', label: 'Ghi chú' },
          { key: 'actions', label: 'Hành động' },
        ],
        pagination: {
          page: 1,
          limit: 20,
          total: 0,
        },
        dataTable: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        loaddingDownload: false,
        loaddingExport: false,
        // Upload file properties
        isUploading: false,
        optionType: [],
        showUploadResultModal: false,
        uploadResult: null,
        isDownloadingError: false,
        showLoading: false,
      }
    },
    async created() {
      this.fetchData()
      this.typeDeviceConfig()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getNameStatus() {
        return code => {
          const map = this.statusOptions.reduce((acc, cur) => {
            acc[cur.id] = cur.text
            return acc
          }, {})
          return map[code] || code || ''
        }
      },
    },
    methods: {
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
      async handleFileUpload(event) {
        const file = event.target.files[0]
        if (!file) return

        // Validate file type
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'text/csv',
        ]
        if (!allowedTypes.includes(file.type)) {
          showMess(
            this,
            'Error',
            'Vui lòng chọn file Excel hoặc CSV',
            'danger',
            'b-toaster-top-right',
            5000
          )
          return
        }

        // Validate file size (10MB)
        const maxSize = 10 * 1024 * 1024
        if (file.size > maxSize) {
          showMess(
            this,
            'Error',
            'Kích thước file không được vượt quá 10MB',
            'danger',
            'b-toaster-top-right',
            5000
          )
          return
        }

        this.isUploading = true

        try {
          const formData = new FormData()
          formData.append('file', file)

          const res = await KpiRoseService.uploadFile(formData)

          if (res.code === 1000) {
            const data = res.data

            // Lưu kết quả upload để hiển thị modal
            this.uploadResult = data
            this.showUploadResultModal = true

            // Refresh data
            await this.fetchData()

            // Hiển thị thông báo chung
            const message =
              data.errorCount > 0
                ? `Tải file hoàn tất. Thành công: ${data.successCount}, Thất bại: ${data.errorCount}`
                : 'Tải file thành công'

            showMess(
              this,
              data.errorCount > 0 ? 'Warning' : 'Success',
              message,
              data.errorCount > 0 ? 'warning' : 'success',
              'b-toaster-top-right',
              5000
            )
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Tải file thất bại',
              'danger',
              'b-toaster-top-right',
              5000
            )
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Có lỗi xảy ra khi tải file',
            'danger',
            'b-toaster-top-right',
            5000
          )
        } finally {
          this.isUploading = false
          // Reset input file
          this.$refs.fileInput.value = ''
        }
      },

      closeUploadResultModal() {
        this.showUploadResultModal = false
        this.uploadResult = null
      },

      async downloadErrorFile() {
        if (
          !this.uploadResult ||
          !this.uploadResult.errors ||
          this.uploadResult.errors.length === 0
        ) {
          showMess(
            this,
            'Warning',
            'Không có dữ liệu lỗi để tải',
            'warning',
            'b-toaster-top-right',
            3000
          )
          return
        }

        this.isDownloadingError = true

        try {
          await KpiRoseService.downloadErrorFile(this.uploadResult.errors)

          showMess(
            this,
            'Success',
            'Tải file lỗi thành công',
            'success',
            'b-toaster-top-right',
            3000
          )
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Có lỗi xảy ra khi tải file lỗi',
            'danger',
            'b-toaster-top-right',
            5000
          )
        } finally {
          this.isDownloadingError = false
        }
      },

      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async exportDataListToExcel() {
        // AI
        try {
          // AI
          this.showLoading = true // AI
          const payload = {
            ...this.filterInvalidData(this.filters), // AI
            page: this.pagination.page, // AI
            limit: this.pagination.limit, // AI
          } // AI
          const body = {
            // AI
            object: payload, // AI
            type: 'CNPS_SUR_PERF_MANAGE_DEVICE_KPI', // AI
          } // AI
          const data = await CommonService.receiveFile(body) // AI
          if (data.success) {
            // AI
            this.openModalLoadFile(data.data.id) // AI
          } // AI
        } catch (error) {
          // AI
          console.log(error) // AI
        } finally {
          // AI
          this.showLoading = false // AI
        } // AI
      }, // AI

      async exportExcel() {
        this.loaddingExport = true
        try {
          await KpiRoseService.dowTemplate({})
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Có lỗi xảy ra khi tải file',
            'danger',
            'b-toaster-top-right',
            5000
          )
        } finally {
          this.loaddingExport = false
        }
      },

      transformDate() {
        this.filters.recordStartDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.filters.recordEndDate = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      // Upload file methods
      triggerFileUpload() {
        this.$refs.fileInput.click()
      },

      filterInvalidData(data) {
        if (!data || typeof data !== 'object') {
          return {}
        }

        const result = { ...data }
        let hasInvalidValues = false

        for (const key in result) {
          const value = result[key]
          if (value === null || value === undefined || value === '0' || value === '') {
            delete result[key]
            hasInvalidValues = true
          }
        }
        return hasInvalidValues ? result : data
      },
      submitForm() {
        this.pagination.page = 1
        this.fetchData()
      },
      clearSearch() {
        this.filters = {}
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.fetchData()
      },

      async fetchData() {
        try {
          this.isLoading = true
          const payload = this.filterInvalidData(this.filters)
          console.log(payload)

          const res = await KpiRoseService.getList({
            ...payload,
            page: this.pagination.page,
            limit: this.pagination.limit,
          })
          if (res.code === 1000) {
            this.dataTable = res.data?.data?.manageDeviceKpiResList || []
            this.pagination.total = res.data?.data?.count ?? 0
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.fetchData()
      },
    },
  }
</script>

<style scoped>
  .content-sync-cell {
    max-width: 300px;
    word-wrap: break-word;
  }

  .content-list {
    margin: 0;
    padding-left: 20px;
    font-size: 12px;
    line-height: 1.4;
  }

  .content-list li {
    margin-bottom: 2px;
  }

  .content-list strong {
    color: #495057;
  }

  .error-list-container {
    font-size: 14px;
  }

  .error-list-container ul {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 10px;
    background-color: #f8f9fa;
  }

  .error-list-container li {
    padding: 5px 0;
    border-bottom: 1px solid #e9ecef;
  }

  .error-list-container li:last-child {
    border-bottom: none;
  }
</style>
